
import React from 'react';

const Menu = (): JSX.Element => {
    return (
        <path d="M12 18.0251H3V16.0251H12V18.0251ZM21 13.0251H3V11.0251H21V13.0251ZM21 8.02515H12V6.02515H21V8.02515Z" />
    );
};

export default Menu;
